import IPickListItem from "../commons/IPickListItem";
import moment from "moment";

export class SolicitacaoSemPrestadorModel extends IPickListItem {
    idServico: number;
    nomeCliente: string;
    nomeSolicitante: string;
    telefone: string;
    email: string;
    enderecoCompleto: string;
    dataCriacao: Date;
    tipoServico: string;

  constructor(
    idServico: number,
    nomeCliente: string,
    nomeSolicitante: string,
    telefone: string,
    email: string,
    enderecoCompleto: string,
    dataCriacao: Date,
    tipoServico: string,
  ) {
    super();
    this.idServico = idServico;
    this.nomeCliente = nomeCliente;
    this.nomeSolicitante = nomeSolicitante;
    this.telefone = telefone;
    this.email = email;
    this.enderecoCompleto = enderecoCompleto;
    this.dataCriacao = dataCriacao;
    this.tipoServico = tipoServico;
  }
  
  get key(): string {
    return `${this.idServico}`;
  }

  get descricao(): string {
    return `${this.idServico} - ${moment(this.dataCriacao).format("DD/MM/YYYY")} - ${
      this.tipoServico
    } -  ${this.nomeCliente}`;
  }
  
}
